// 引入axios组件
import axios from 'axios';
import qs from 'qs'; // 处理数据  qs.stringify(params)
import { checkRule } from '@/assets/js/public';
// 引入公共js文件
export default {
  data() {
    return {
      title: '', // 面包屑标题
      search: '',
      modal1: false, // 模态框显示开关，true显示   false不显示
      param: '',
      putpage: '', // 存储页数
      spinShow: true,
      // data:[],
      // page: 1,
      columns7: [
        {
          // type: 'index',
          title: '排序',
          width: 100,
          align: 'center',
          key: 'sort_no',
          // sortable:true,
          render: (h, params) => {
            const self = this;
            return h('div', [
              h('Input', {
                props: {
                  placeholder: '请输入',
                  value: params.row.sort_no,
                  // 'v-model':value
                },
                on: {
                  'on-blur': (event) => {
                    const sort = event.target.value;
                    this.getSort(sort, params.row.id);
                  },
                },
              }),
            ]);
          },
        },
        {
          title: '文章标题',
          key: 'arttitle',
          render: (h, params) => h('div', [h('strong', params.row.arttitle)]),
        },
        {
          title: '作者',
          key: 'another',
        },
        {
          title: '所属分类',
          key: 'cat_name',
        },
        {
          title: '添加时间',
          key: 'putime',
        },
        {
          title: '修改时间',
          key: 'uptime',
        },
        {
          title: '是否置顶',
          key: 'is_top',
          width: 150,
          align: 'center',
          render: (h, params) =>
            h('div', [
              h(
                'Button',
                {
                  props: {
                    type: 'success',
                    size: 'small',
                  },
                  style: {
                    marginRight: '5px',
                  },
                  on: {
                    click: () => {
                      this.is_top(params.row.id);
                    },
                  },
                },
                params.row.topstatus,
              ),
            ]),
        },
        {
          title: '操作选项',
          key: 'action',
          width: 150,
          align: 'center',
          render: (h, params) =>
            h('div', [
              h(
                'Button',
                {
                  props: {
                    type: 'info',
                    size: 'small',
                  },
                  style: {
                    marginRight: '5px',
                  },
                  on: {
                    click: () => {
                      this.show(params.row.id);
                      // this.show(params);
                    },
                  },
                },
                '编辑',
              ),
              h(
                'Button',
                {
                  props: {
                    type: 'error',
                    size: 'small',
                  },
                  style: {
                    marginRight: '5px',
                  },
                  on: {
                    click: () => {
                      this.remove(params);
                    },
                  },
                },
                '删除',
              ),
            ]),
        },
      ],
    };
  },
  created() {
    const self = this;
    this.$Spin.show();
    setTimeout(() => {
      this.$Spin.hide();
    }, 1500);
    const spage = this.$route.query.page;
    const asearch = this.$route.query.search;
    axios({
      method: 'post',
      url: '/admin/article/articleList',
      data: { page: spage, search: asearch },
    })
      .then((response) => {
        checkRule(response, self); // 检查是否有权限

        self.putpage = spage;
        self.$store.commit('getArticleList', response.data);
      })
      .catch((response) => {
        console.log(response);
      });
  },
  // 用来获取VUEX中的文件
  computed: {
    data() {
      return this.$store.state.article.articleListshow;
    },
    page() {
      return this.$store.state.article.articleList.total;
    },
  }, //* /
  methods: {
    // 置顶方法
    is_top(artid) {
      const self = this;
      axios({
        method: 'post',
        url: '/admin/article/articleIsTop',
        data: {
          artid,
        },
      })
        .then((response) => {
          checkRule(response, self); // 检查是否有权限
          console.log(response.data.code);
          if (response.data.code == 1) {
            self.$store.commit(
              'getArticleListAgain',
              self.putpage,
              self.search,
            );
            self.$Message.success('操作成功');
          } else if (
            response.data.code != 1 &&
            response.data.code != undefined
          ) {
            self.$Message.error('操作失败');
          }
        })
        .catch((response) => {
          // console.log('请求失败');
        });
    },
    // 更新排序方法
    getSort(value, artid) {
      const self = this;
      for (const el of self.data) {
        console.log(el.id);
        if (el.id == artid) {
          el.sort_no = value;
        }
      }
      // 更新排序请求
      axios({
        method: 'post',
        url: '/admin/article/articleSort',
        data: {
          param: this.data,
        },
      })
        .then((response) => {
          checkRule(response, self); // 检查是否有权限

          self.$store.commit('getArticleListAgain', self.putpage, self.search);
          self.$Message.success('操作成功');
        })
        .catch((response) => {
          // console.log('请求失败');
        });
    },
    // 添加文章跳页
    addArticle() {
      console.log(this.data);
      this.$router.push({
        path: '/articleupdate', // 这是路由名称
      });
    },
    // 分页的钩子函数，当跳页的时候重新请求（将页码发给后台）
    getpage(page) {
      this.$Spin.show();
      setTimeout(() => {
        this.$Spin.hide();
      }, 800);
      if (page == undefined) {
        page = 1;
      }
      console.log(page);
      this.putpage = page;
      const self = this;
      axios({
        method: 'post',
        url: '/admin/article/articleList',
        data: {
          page,
          search: self.search,
        },
      })
        .then((response) => {
          self.$store.commit('getArticleList', response.data);
        })
        .catch((response) => {
          console.log('请求失败');
        });
      this.$router.push({
        path: '/article', // 这是路由名称
        query: { page, search: self.search },
      });
    },
    /**
     * 编辑当前用户
     * localStorage html5新定义的属性，存在兼容问题  使用方法参考下边网址
     * https://www.cnblogs.com/st-leslie/p/5617130.html
     * https://segmentfault.com/q/1010000010175869?sort=created
     */
    show(index) {
      this.$router.push({
        path: '/articleupdate', // 这是路由名称
        query: { artid: index, page: this.putpage, search: self.search },
      });
    },
    /**
     * 删除当前文章
     * 同页面刷新不建议使用路由，再此请求数据
     * const定义的变量不可修改
     */
    remove(artid) {
      this.modal1 = true;
      this.param = artid;
    },
    ok() {
      const self = this; // 将this对象附到一个不可更改的变量中~
      axios({
        method: 'post',
        url: '/admin/article/articleDel',
        data: { id: self.param.row.id },
      })
        .then((response) => {
          checkRule(response, self); // 检查是否有权限

          if (response.data.code == 1) {
            const numm = response.data.count;
            const mo = numm % 10; // 判断剩余总数摸10是否是0
            const pagepage = Math.ceil(numm / 10);
            if (
              self.param.index == 0 &&
              self.putpage != 1 &&
              mo == 0 &&
              self.putpage != pagepage
            ) {
              // 判断当前所在页是否是最后一页。
              self.putpage -= 1;
            }
            self.$store.commit(
              'getArticleListAgain',
              self.putpage,
              self.search,
            );
            self.$Message.success(response.data.msg);
          } else {
            self.$Message.error(response.data.msg);
          }
        })
        .catch((response) => {
          // self.$Message.error('请求失败');
        });
    },
    cancel() {
      this.modal1 = false;
    },
  },
};
